import { Controller } from "@hotwired/stimulus"

// Toggles sidebar-mini on body (icons-only narrow sidebar). Persists state in localStorage.
const SIDEBAR_MINI_CLASS = "sidebar-mini"
const STORAGE_KEY = "lte.sidebar.mini"

export default class AdminSidebarController extends Controller {
  connect() {
    this.applyStoredState()
  }

  toggleMini() {
    const mini = document.body.classList.toggle(SIDEBAR_MINI_CLASS)
    this.persist(mini)
  }

  applyStoredState() {
    if (typeof localStorage === "undefined") return
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      if (stored === "true") {
        document.body.classList.add(SIDEBAR_MINI_CLASS)
      } else if (stored === "false") {
        document.body.classList.remove(SIDEBAR_MINI_CLASS)
      }
    } catch (e) {
      console.error("[ADMIN_SIDEBAR] Failed to read sidebar state from localStorage.", e)
    }
  }

  persist(mini) {
    try {
      localStorage.setItem(STORAGE_KEY, String(mini))
    } catch (e) {
      console.error("[ADMIN_SIDEBAR] Failed to persist sidebar state to localStorage.", e)
    }
  }
}
